/* Lily & Ruby — keeps the dots of the mobile card swipe in sync */
(function () {
  function update(track) {
    var dots = track.parentNode.querySelectorAll('.lr-swipe__dots span');
    if (!dots.length || !track.clientWidth) return;
    var i = Math.round(track.scrollLeft / track.clientWidth);
    for (var k = 0; k < dots.length; k++) {
      dots[k].classList.toggle('is-active', k === i);
    }
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('lr-swipe__track')) return;
    if (t._lrRaf) return;
    t._lrRaf = requestAnimationFrame(function () {
      t._lrRaf = 0;
      update(t);
    });
  }, true);
})();
